import api from './api';

export const createUser = async (userData) => {
  try {
    const response = await api.post('/users', userData);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    
    return {
      success: false,
      message: error.response?.data?.error || error.message || 'Failed to create user'
    };
  }
};

export const getUsers = async () => {
  try {
    const response = await api.get('/users');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};